<template>
  <div class="cartpay1">
    <div class="hed">
      <span class="number">订单号码：{{ payOrder.orderNo }}</span>
      <span class="status">{{ payOrder.payStatus.label }}</span>
    </div>
    <div class="ordercon">
      <div class="title1">
        <div class="status2">
          <div class="con1" v-if="payOrder.payStatus.value == '2'">
            <span>等待付款</span>
            <p>剩余{{ minute ? minute : '00' }}分{{ second ? second : '00' }}秒自动关闭</p>
          </div>
          <div class="con1" v-if="payOrder.payStatus.value == '1'">
            <span>付款成功</span>
          </div>
          <div
            class="con1"
            v-if="payOrder.payStatus.value == '-1' || payOrder.payStatus.value == '0'"
          >
            <span>订单时效</span>
            <p class="text">因为您长时间没有支付费用，<br />订单已经失效</p>
          </div>
        </div>
        <div class="condiv" style="margin-top: 10px;">
          <!-- 优惠券单元格 -->
          <van-coupon-cell
            :coupons="couponValidList"
            :chosen-coupon="chosenCoupon"
            @click="showList = true"
          />
          <van-action-sheet v-model="showList" title="选择优惠券">
            <!-- 优惠券列表 -->
            <van-coupon-list
                :coupons="couponValidList"
                :chosen-coupon="chosenCoupon"
                :disabled-coupons="couponInvalidList"
                @change="onChange"
                @exchange="onExchange"
              />
          </van-action-sheet>
        </div>
        <div
          v-if="payOrder.orderType.value !== 'maintain'"
          style="background-color: white; padding: 1rem; margin-top: 1rem;"
        >
          <div style="font-size: 1.5rem; padding-top: 1rem; height: 3rem;">
            提货点
          </div>
          <div style="font-size: 1.3rem; padding-top: 1rem; height: 3rem;">
            嘉盛陵园
          </div>
        </div>
      </div>
      <div class="content">
        <template v-if="payOrder.orderType.value == 'shop' || payOrder.orderType.value == 'replace'
            || payOrder.orderType.value == 'rented' || payOrder.orderType.value == 'subscribe'">
          <section v-for="(item, index) in payOrder.goodsList" :key="index">
            <div class="img">
              <img :src="item.firstPhoto" />
            </div>
            <div class="text">
              <p class="title">{{ item.proName }}</p>
              <p class="ms">规格: {{ $properties(item.specification, 'label')}}</p>
              <div class="amount">
                <span class="price">￥{{ item.price }}</span>
                <span class="no">× &nbsp;{{ item.count }}</span>
              </div>
            </div>
          </section>
        </template>
        <template v-if="payOrder.orderType.value == 'maintain'">
          <div class="main">
            <p class="title">墓位编号：{{ payOrder.maintainAddress }}</p>
            <p class="title">
              缴费项目：{{ payOrder.maintainList[0].price }}年 ￥{{
                payOrder.maintainList[0].price
              }}
            </p>
          </div>
        </template>
      </div>
      <div class="ma">
        <span class="ordertime"
          >下单时间&nbsp;&nbsp; <span>{{ payOrder.orderDate }}</span></span>
        <p class="ordertime">
          订单备注&nbsp;&nbsp; <span>{{ payOrder.customMemo }}</span>
        </p>
      </div>
    </div>
    <!-- <div class="bottom">
      <ul>
        <li>
          <div class="pay" style="display: none;">去支付</div>
        </li>
        <li><div class="pay">我的订单</div></li>
        <li>
          <div class="delete" style="display: none;">下载发票</div>
        </li>
        
        <li>
          <div class="pay" style="display: none;">评价</div>
        </li>
        <li><div class="delete">删除订单</div></li>
        <li>
          <div class="delete" style="display: none;">取消订单</div>
        </li>
      </ul>
    </div> -->
    <div class="clear-both"></div>
    <section class="foot">
      <p class="price">
        需要支付：<i>¥ {{ payOrder.amount }}</i>
      </p>
      <a class="goto" @click="submitPay()">支付</a>
    </section>

    <!-- <div class="">
      <div class="success">
        <p class="title">支付成功</p>
        <span class="text">您已成功支付<br />可在我的订单查看订单详情</span>
      </div>
    </div> -->
  </div>
</template>

<script>
// const coupon = {
//   available: 1,
//   condition: '无使用门槛\n最多优惠12元',
//   reason: '',
//   value: 150,
//   name: '优惠券名称',
//   startAt: 1489104000,
//   endAt: 1514592000,
//   valueDesc: '1.5',
//   unitDesc: '元',
// }
import moment from 'moment'
import { pay } from '@/api/PayModel'
export default {
  name: 'cart',
  data() {
    return {
      
      // coupons: [coupon, coupon],
      // disabledCoupons: [coupon],
      showList: false,
      payOrder: {
        orderNo: '',
        customMemo: '',
        orderDate: '',
        specification: {},
        amount: 0,
        maintainAddress: '',
        orderType: {},
        payStatus: {},
        goodsList: [],
        maintainList: [],
      },
      chosenCoupon: -1,
      couponValidList: [],
      couponInvalidList: [],
      times: '',
      orderTimer: null,
      minute: '',
      second: '',
      timeFlag: false,
    }
  },
  created() {
    this.showList = false
    var params = this.$route.query
    var orderNo = params['orderNo']
    this.queryOrderOne(orderNo)
  },
  methods: {
    /**
     * 实现倒计时
     * @params startTime: 开始时间戳  endTime: 结束时间戳
     */
    countDownFun(startTime, endTime) {
      const that = this
      var setInterval1 = setInterval(function() {
        if (!that.timeFlag) {
          clearInterval(setInterval1)
          return
        }
        var ts = endTime - startTime //计算剩余的毫秒数
        var mm = Math.floor((ts / 1000 / 60) % 60)
        var ss = Math.floor((ts / 1000) % 60)
        mm = that.checkTime(mm)
        ss = that.checkTime(ss)
        if (ts > 500) {
          that.minute = mm
          that.second = ss
          startTime += 1000
        } else if (ts < 500) {
          console.log('重新获取数据')
          that.timeFlag = false
          that.showList = false
          var params = that.$route.query
          var orderNo = params['orderNo']
          that.queryOrderOne(orderNo)
          clearInterval(setInterval1)
        }
      }, 1000)
    },
    /**小于0的前面补零 */
    checkTime(i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    onChange(index) {
      this.showList = false
      this.chosenCoupon = index
      var newAmount = this.payOrder.amount
      if(this.chosenCoupon>=0) {
        newAmount = newAmount - this.couponValidList[this.chosenCoupon].value/100
      }
      if(newAmount<0){
        newAmount = 0
      }
      this.payOrder.amount = newAmount
    },
    onExchange(code) {
      this.coupons.push(code)
    },
    queryOrderOne(orderNo) {
      var that = this
      this.$queryOne(
        '/api/order/queryOrderByNo',
        { orderNo: orderNo, myId: this.$store.getters.userId },
        function(res) {
          that.$fill(that.payOrder, res['data'])
          if (that.payOrder.payStatus.value == '2') {
            let _startTime = that.payOrder.orderDate
            _startTime = new Date(_startTime)
            let _min = _startTime.getMinutes()
            _startTime.setMinutes(_min + 30)
            if (new Date() < _startTime) {
              that.timeFlag = true
              that.countDownFun(Date.parse(new Date()), Date.parse(_startTime))
            } else {
              that.timeFlag = false
            }
          }
          for (var validIndex in res.couponValidList) {
            var validItem = res.couponValidList[validIndex].actCoupon
            that.couponValidList.push({
              id: res.couponValidList[validIndex].id,
              available: 1,
              condition: validItem.labels.join('\n'),
              reason: '',
              value: validItem.amount*100,
              name: validItem.name,
              startAt: Number(moment(validItem.limitStartDate, 'YYYY-MM-DD HH:mm:ss').format("X")),
              endAt: Number(moment(validItem.limitEndDate, 'YYYY-MM-DD HH:mm:ss').format("X")),
              valueDesc: validItem.amount,
              unitDesc: '元',
            })
          }
          for (var invalidIndex in res.couponInvalidList) {
            var invalidItem = res.couponInvalidList[invalidIndex].actCoupon
            that.couponInvalidList.push({
              id: res.couponInvalidList[invalidItem].id,
              available: 1,
              condition: invalidItem.labels.join('\n'),
              reason: '',
              value: invalidItem.amount*100,
              name: invalidItem.name,
              startAt: Number(moment(invalidItem.limitStartDate, 'YYYY-MM-DD HH:mm:ss').format("X")),
              endAt: Number(moment(invalidItem.limitEndDate, 'YYYY-MM-DD HH:mm:ss').format("X")),
              valueDesc: invalidItem.amount,
              unitDesc: '元',
            })
          }
        }
      )
    },
    submitPay() {
      var param = {orderNo: this.payOrder.orderNo,myId:this.$store.getters.userId,openid:this.$store.getters.user['openid']}
      if(this.chosenCoupon>-1){
        param['couponId'] = this.couponValidList[this.chosenCoupon].id
      }
      pay(param)
    },
  },
  beforeDestroy() {
    clearInterval(this.orderTimer)
  },
}
</script>

<style>
.cartpay1 .bottom {
  height: 4.9rem;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 5rem;
  z-index: 999;
  border: 0.1rem solid #eee;
}
.cartpay1 .bottom ul li {
  margin-top: 1rem;
}
.cartpay1 .bottom ul li .pay {
  background-color: #15a892;
  color: #fff;
  float: right;
}

.cartpay1 .bottom ul li div {
  width: 8rem;
  height: 3rem;
  border: 0.1rem solid #eee;
  font-size: 1.3rem;
  list-style: none;
  float: left;
  margin-right: 1rem;
  padding-top: 0.6rem;
  text-align: center;
}
.cartpay1 .bottom ul li .pay {
  background-color: #15a892;
  color: #fff;
  float: right;
}
.cartpay1 .bottom ul li .delete {
  color: #999;
  float: right;
}
.cartpay1 .hed span {
  font-size: 1.4rem;
}
.cartpay1 .hed .status {
  float: right;
  position: relative;
  right: 1.5rem;
  color: #15a892;
}
.cartpay1 .hed {
  width: 100%;
  height: 4.6rem;
  background-color: #fff;
  font-size: 1.4rem;
  padding-left: 2rem;
  letter-spacing: 0.1rem;
  padding-top: 1.3rem;
}
.cartpay1 .ordercon {
  margin-top: -2rem;
  padding: 0 1rem;
  background: #f3f3f3;
  height: 10rem;
}

.cartpay1 .ordercon .title1 {
  width: 100%;
  font-size: 1.3rem;
}
.cartpay1 .status2 {
  width: 100%;
  margin-top: 3rem;
  /* padding: 0 1rem; */
  letter-spacing: 0.1rem;
}
.cartpay1 .status2 .con1 {
  width: 100%;
  text-align: center;
  padding: 1.9rem 2rem;
  font-size: 1.6rem;
  line-height: 2.5rem;
  background-color: #15a892;
}
.cartpay1 .status2 .con1 .cha,
.cartpay1 .status2 .con1 .svg11 {
  width: 1.5rem;
  height: 1.5rem;
  position: relative;
  top: 0.2rem;
}
.cartpay1 .status2 .con1 p,
.cartpay1 .status2 .con1 span {
  color: #fff;
}
.cartpay1 .status2 .con1 p,
.cartpay1 .status2 .con1 span {
  color: #fff;
}
.cartpay1 .status2 p {
  font-size: 1.4rem;
  margin-top: 0.5rem;
}
.cartpay1 .condiv {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.cartpay1 .condiv .title {
  padding: 1.3rem 0;
  line-height: 2rem;
}

.cartpay1 .ordercon .content {
  margin-top: 1rem;
  background-color: #fff;
}
.cartpay1 .ordercon .content section {
  height: 10rem;
  padding: 1rem;
  box-sizing: border-box;
  font-size: 1.4rem;
  display: flex;
  border-bottom: 1px solid #eee;
}
.cartpay1 .ordercon .content section .img img {
  width: 8rem;
  height: 8rem;
  margin-right: 1.3rem;
}
.cartpay1 .ordercon .content section .text {
  width: 100%;
}
.cartpay1 .ordercon .content section .text .title {
  height: 3.7rem;
  line-height: 2rem;
  overflow: hidden;
}
.cartpay1 .ordercon .content section .text .ms {
  height: 1.7rem;
  font-size: 1.2rem;
  color: #999;
}
.cartpay1 .ordercon .content section .text .amount {
  display: flex;
  justify-content: space-between;
  line-height: 2.2rem;
}
.cartpay1 .ordercon .content section .text .amount .price {
  font-size: 1.6rem;
  color: #15a892;
  padding-top: 0.4rem;
  font-weight: bolder;
}
.cartpay1 .ma {
  height: 6rem;
  font-size: 1.4rem;
}
.cartpay1 .main {
  height: 6rem;
  font-size: 1.4rem;
  background: #fff;
  left: 0;
  right: 0;
  padding: 0.5rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  width: 100%;
  line-height: 2.5rem;
}
.cartpay1 .order-remark,
.cartpay1 .ma {
  background: #fff;
  left: 0;
  right: 0;
  padding: 0.5rem 1rem;
  margin-top: 1rem;
  margin-bottom: 6rem;
  width: 100%;
}
.cartpay1 .ma .ordertime {
  color: #999;
}
.cartpay1 .ma .ordertime {
  color: #999;
}

.cartpay1 .ma p {
  margin-top: 1rem;
}
.cartpay1 .clear-both {
  clear: both;
  height: 5rem;
}
.cartpay1 .foot {
  background: #fff;
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 1.4rem;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  display: flex;
  justify-content: flex-end;
}
.cartpay1 .foot .price {
  margin: 0 1.7rem 0 0;
}
.cartpay1 .foot .price i {
  color: #15a892;
  font-weight: bolder;
}
.cartpay1 .foot .goto {
  background: #15a892;
  color: #fff;
  width: 13.5rem;
  text-align: center;
}
.cartpay1 .success {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  visibility: hidden;
  opacity: 0;
  transition: all 1s ease;
  border: 1px solid #eee;
  width: 22rem;
  padding: 3rem 1rem;
  font-size: 1.4rem;
  border-radius: 0.5rem;
  text-align: center;
  background: #fff;
  box-shadow: 1px 2px 5px rgb(0 0 0 / 20%);
}
.cartpay1 .success .title {
  color: #15a892;
}
.cartpay1 .success .title:before {
  width: 5.5rem;
  height: 5.5rem;
  margin: 0 auto 1rem;
  display: block;
  content: '';
  /* background: url() no-repeat 50%; */
  background-size: contain;
}
.cartpay1 .success .text {
  color: #999;
  line-height: 2.4rem;
  margin-top: 2.4rem;
  display: block;
}
.van-coupon-list__exchange-bar {
  display: none;
}
</style>
